var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreetLightError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 36,
    width: 44,
    fill: "#CE2424",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "239.098,480.653 227.08,361.729 145.454,361.729 133.437,480.653 125.928,480.653 125.928,512 130.27,512  242.266,512 246.607,512 246.607,480.653  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M331.176,128.008c-2.463-42.116-37.493-75.628-80.216-75.628c-18.442,0-35.442,6.26-49.019,16.746V31.347h20.376V0 h-20.376h-31.347h-20.375v31.347h20.375v101.401v21.897v177.894h31.347V154.645v-21.897c0-27.029,21.99-49.019,49.019-49.019 c25.46,0,46.442,19.512,48.794,44.368c-31.192,7.231-54.519,35.226-54.519,68.586c0,0.368,0.009,0.734,0.022,1.098l0.278,15.521 h54.444v17.737h31.347v-17.737h39.048l15.397,0.018l0.274-15.394l0.005-0.143c0.013-0.365,0.022-0.73,0.022-1.098 C386.072,163.187,362.559,135.099,331.176,128.008z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreetLightError);
export default __webpack_public_path__ + "static/media/street-light-error.6c4a6a30213f91490bc764736a7e9f5a.svg";
export { ForwardRef as ReactComponent };